<template>
  <div class="legend-container">
    <div class="legend-item" :title="item.name" v-for="(item, index) in data" :key="index">
      <svg class="color-box" viewBox="0 0 12 12" height="12" width="12">
        <rect width="12" height="12" :fill="item.color"></rect>
      </svg>
      <span class="group-name truncate">{{ item.name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data'],
}
</script>

<style lang="scss" scoped>
.legend-container {
  display: flex;
  flex-direction: column;
  border: 1px solid #ccc;
  padding: 10px 10px 10px 15px; /* Added extra left padding */
  border-radius: 4px;
  background-color: #f9f9f9;
  margin-left: 12px;
}

.legend-item {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.color-box {
  margin-right: 8px;
  min-width: 12px;
}

.group-name {
  font-size: 14px;
}

/* Optional: Remove margin from the last item to keep the spacing consistent */
.legend-item:last-child {
  margin-bottom: 0;
}
</style>